<template>
  <div class="agb-data">
    <h2 class="text-3xl"><slot name="txtAGB">AGB</slot></h2>
    <p class="agb-consent">
      <slot name="lblAgbConsent"
        >Ja, ich willige in die Erhebung, Speicherung und Nutzung meiner personenbezogenen Daten zum Zwecke der
        Vertragsdurchführung und Identifizierung (§9AGB) ein. Mit der Registrierung erkenne ich die AGB für
        Mobilfunkdienstleistungen, die vertraglichen Datenschutzhinweise sowie die Leistungsbeschreibungen und Preislisten an.
      </slot>
    </p>
    <p class="agb-information-article">
      <slot :name="`lblInformationArticle${tariffIdentifier}`"
        >Es gilt das Informationsblatt zu Internetzugangsdiensten und das Produktinformationblatt.
      </slot>
    </p>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import syncProperty from '../../../../mixins/syncProperty'

export default {
  name: 'AGB',
  props: {
    consent: {
      type: String
    }
  },
  created() {
    this.selectedConsentAGB = true
    this.selectedInformationArticle = true
  },
  computed: {
    ...mapGetters('activation/info', ['tariffIdentifier'])
  },
  mixins: [
    syncProperty('consentAGBProp', 'selectedConsentAGB'),
    syncProperty('consentInformationArticleProp', 'selectedInformationArticle')
  ]
}
</script>
